export const masks = {
  IBAN: 'SS00 0000 0000 0000 0000 00'
};
